import { render } from "./PromotionLine.vue?vue&type=template&id=741e43e3&scoped=true&lang=pug"
import script from "./PromotionLine.vue?vue&type=script&lang=js"
export * from "./PromotionLine.vue?vue&type=script&lang=js"

import "./PromotionLine.vue?vue&type=style&index=0&id=741e43e3&scoped=true&lang=sass"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741e43e3"]])

export default __exports__